import { css } from 'styled-components';
import { f as focusShadow } from './focusShadow-4fdc6b22.js';

const focusBorder = /*#__PURE__*/css(["border:", ";", ""], ({
  theme: {
    focusVisible: {
      borderWidth,
      borderStyle,
      borderColor
    }
  }
}) => `${borderWidth} ${borderStyle} ${borderColor}`, focusShadow);
var focusBorder$1 = focusBorder;

export { focusBorder$1 as f };
//# sourceMappingURL=focusBorder-3d45e6ae.js.map
